/* 🤖 this file was generated by svg-to-ts */
export const matIconMobileScreenShare: {
  name: 'mobile-screen-share';
  data: string;
} = {
  name: 'mobile-screen-share',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 1H7c-1.1 0-1.99.85-1.99 1.95v18C5.01 22.05 5.9 23 7 23h10c1.1 0 2-.95 2-2.05v-18C19 1.85 18.1 1 17 1zm0 18H7V5h10v14zm-4.2-5.76v1.75L16 12l-3.2-2.98v1.7c-3.11.43-4.35 2.56-4.8 4.7 1.11-1.5 2.58-2.18 4.8-2.18z"/></svg>`
};
